module.exports = __webpack_public_path__ + "static/media/consejo_nacional.be4cf440.png";